export enum SessionGuideEvents {
  sessionGuideGoalStatusDropdownClicked = 'Session Guide Goal Status Dropdown Clicked',
  sessionGuideGoalStatusOptionSelected = 'Session Guide Goal Status Dropdown Menu Option Selected',
  sessionGuideGoalDescriptionFocused = 'Focus On Session Guide Goal Description Field',
  sessionGuideGoalDescriptionBlurred = 'Focus Off Session Guide Goal Description Field',
  sessionGuideFrequencyDropdownClicked = 'Session Guide Frequency Dropdown Clicked',
  sessionGuideFrequencyOptionSelected = 'Session Guide Frequency Dropdown Menu Option Selected',
  sessionGuideFrequencyConfirmed = 'Session Guide Frequency Confirm Button Clicked',
  sessionGuideInterventionStatusDropdownClicked = 'Session Guide Intervention Status Dropdown Clicked',
  sessionGuideInterventionStatusOptionSelected = 'Session Guide Intervention Status Dropdown Menu Option Selected',
}
